import { sendRequest } from "../../hooks/requests/useRequest";

export async function getInformationWorkOrderLogs(_id_work_Order) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `WorkOrder/WorkOrderLogs/${_id_work_Order}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}

export async function getInformationTraceability(_id_work_Order) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Sass/GetTraceability/${_id_work_Order}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}

// * -----
export async function getReportCompany(_dateStart, _dateEnd, _id_client = null, _id_agreement = null, _loading = false, _view1 = false) {

    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Reports/GetReporCompany/${_dateStart}/${_dateEnd}${_id_client == null ? "" : "?id_company=" + _id_client}${_id_agreement == null ? "" : "&id_agreement=" + _id_agreement}`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response.data
        }
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}